var imagesLoaded = require("imagesloaded");
let $ = require("jquery");
imagesLoaded.makeJQueryPlugin($);
require("slick-carousel");

// import Swiper bundle with all modules installed
import Swiper from "swiper/bundle";

// require('jquery-zoom');
import { getUrlWithVariant, ProductForm } from "@shopify/theme-product-form";

$(function () {
  $(".template-product .description-container p").each(function () {
    var gettt = $(this).text().length == 1;
    if (gettt) {
      $(this).remove();
    }
  });

  let colorLookup = {},
    sizeLookup = {},
    mainImageSlider = $("#main-image-slider"),
    mainImageSliderSource = $("#main-image-slider-source"),
    thumbnailSlider = $("#thumbnail-slider"),
    thumbnailSliderSource = $("#thumbnail-slider-source"),
    colorHiddenInput = $("#color-selection"),
    colorOptions = $(".color-options .color-option-item"),
    colorSelectionLabel = $(".color-selected-label"),
    sizeInput = $("#size-selection"),
    sizeOptions = sizeInput.find("option"),
    quantityInput = $("#quantity-input"),
    quantityIncrement = $("#quantity-increment"),
    quantityDecrement = $("#quantity-decrement"),
    isSockProduct = $(".product-detail-container-inner[data-sock-product]").length
      ? JSON.parse($(".product-detail-container-inner[data-sock-product]").attr("data-sock-product"))
      : false;

  // console.log('isSockProduct',isSockProduct)

  function disableUnavailableOptions() {
    // NOTE: We're allowing all colors now, so this is commented out. If we want to disable colors, we can use this.
    // $('.color-option-item').each(function () {
    //     let color = $(this).data('value');
    //     if(!colorLookup[color]) $(this).prop('disabled', true);
    // });

    $(".size-option").each(function () {
      let size = $(this).find("input").val();
      if (!sizeLookup[size]) $(this).prop("disabled", true);
    });
  }

  function setInitialColorVariant() {
    console.log("setInitialColorVariant called");
    let variant = null;

    // If there's a variant in the URL, select that variant on the PDP
    if (getQueryParams(window.location.href).variant) {
      variant = window.product_variant_data.find(function (variant) {
        return variant.id === parseInt(getQueryParams(window.location.href).variant);
      });
    }

    // If there's a sku in the URL, select that variant on the PDP
    if (!variant && getQueryParams(window.location.href).sku) {
      variant = window.product_variant_data.find(function (variant) {
        return variant.sku === getQueryParams(window.location.href).sku;
      });
    }
    console.log('setInitialColorVariant', variant);

    if (!variant) {
      $(".color-option-item").first().trigger("click");
      changeImage(); // this is here to handle products without colors like gift cards
      return;
    }

    let variantName = $(`#product-variant-selection option[value="${variant.id}"]`).text();
    let optionValues = variantName.split(" / ");
    // console.log('colorLookup: ',colorLookup)
    // console.log('sizeLookup: ',sizeLookup)
    $(".product-option-group").each(function (i) {
      $(this).find(".color-selected-label").text(optionValues[i]);
      $(this).find('input[type="hidden"]').val(optionValues[i]);

      $(this).find(`[data-value="${optionValues[i]}"]`).addClass("selected").siblings().removeClass("selected");

      if ($(this).data("option-name") === "Color") {
        if (colorLookup[optionValues[i]]) {
          setAvailableSizes(optionValues[i]);
        } else {
          console.log("color is OOS", optionValues[i]);
        }
      }
      if ($(this).data("option-name") === "Size") {
        // console.log('sizeLookup',sizeLookup,optionValues[i])
        // if (sizeLookup[optionValues[i]]) {
        //   setAvailableColors(optionValues[i]);
        // }
      }
      // changeImage();
    });
    // setTimeout(function() {
    //     if(window.klaviyoProduct.options[0] === 'Color') {
    //         $('[data-value="' + variant.option1 + '"]').click();
    //     } else {
    //         $('[data-value="' + variant.option2 + '"]').click();
    //     }
    // }, 500);
    changeImage();
  }
  let mySwiper;
  function destroySwiperSlider() {
    if ($(".mySwiper").hasClass("swiper-initialized")) {
      // mySwiper.destroy(false);
      mySwiper.removeAllSlides();
    }
  }

  function initSwiperSlider() {
    if ($(".mySwiper").hasClass("swiper-initialized")) {
      mySwiper.update();
      mySwiper.slideTo(0, 0);
      console.log("update re-init swiper");
    } else {
      mySwiper = new Swiper(".mySwiper", {
        scrollbar: {
          el: ".swiper-scrollbar",
          // hide: true,
        },
      });
    }
  }

  let mySockSwiper;
  function destroySockSwiperSlider() {
    if ($(".mySockSwiper").hasClass("swiper-initialized")) {
      // mySwiper.destroy(false);
      mySockSwiper.removeAllSlides();
    }
  }

  function initSockSwiperSlider() {
    if ($(".mySockSwiper").hasClass("swiper-initialized")) {
      mySockSwiper.update();
      mySockSwiper.slideTo(0, 0);
      console.log("update re-init Sock swiper");
    } else {
      mySockSwiper = new Swiper(".mySockSwiper", {
        scrollbar: {
          el: ".swiper-scrollbar",
          // hide: true,
        },
      });
    }
  }

  function destroySliders() {
    if (mainImageSlider.hasClass("slick-initialized")) {
      mainImageSlider.slick("unslick");
      mainImageSlider.addClass("hide-while-loading");
    }
    if (thumbnailSlider.hasClass("slick-initialized")) {
      thumbnailSlider.slick("unslick");
      thumbnailSlider.addClass("hide-while-loading");
    }
  }

  function initializeSliders() {
    let prevArrow =
      '<button type="button" class="slick-prev"><svg class="image-gallery-svg" xmlns="http://www.w3.org/2000/svg" viewBox="6 0 12 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg></button>';
    let nextArrow =
      '<button type="button" class="slick-next"><svg class="image-gallery-svg" xmlns="http://www.w3.org/2000/svg" viewBox="6 0 12 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></button>';

    mainImageSlider.not(".slick-initialized").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      cssEase: "linear",
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      // asNavFor: thumbnailSlider,
      fade: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: true,
            fade: $("body.template-product.styles-tavi").length ? false : true,
            infinite: $("body.template-product.styles-tavi").length ? false : true,
            dots: true,
          },
        },
      ],
    });

    thumbnailSlider.not(".slick-initialized").slick({
      vertical: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      // asNavFor: mainImageSlider,
      dots: false,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      adaptiveHeight: true,
    });

    mainImageSlider.removeClass("hide-while-loading");
    thumbnailSlider.removeClass("hide-while-loading");

    thumbnailSlider.find(".image-thumbnail-item").on("click", function () {
      let index = $(this).closest(".slick-slide").data("slick-index");
      mainImageSlider.slick("slickGoTo", index);
    });
  }

  // Workaround to get the size options to sort properly, since Shopify's
  // admin doesn't honor the sorting for secondary options
  function sortSizeOptions() {
    /* keeping this around in case we go back to the native select
    let $sizeOptionsContainer = $('#size-selection');
    let options = $sizeOptionsContainer.find('option');
    const sizeSort = ['XS','S','M','L','XL','XXL'];
    options.sort((a, b) => {
      return sizeSort.indexOf($(a).attr('value')) - sizeSort.indexOf($(b).attr('value')) || -1;
    });
    $sizeOptionsContainer.html('');
    options.appendTo($sizeOptionsContainer);
    */

    let $sizeOptionsContainer = $("#size-overlay-options");
    let options = $sizeOptionsContainer.find("li");
    // console.log('un sorted options',options);
    const sizeSort = ["XS", "S", "M", "L", "XL", "XXL"];
    options.sort((a, b) => {
      return (
        sizeSort.indexOf($(a).find("button").data("sort-value")) - sizeSort.indexOf($(b).find("button").data("sort-value")) || -1
      );
    });
    // console.log('sorted options',options);
    $sizeOptionsContainer.html("");
    options.appendTo($sizeOptionsContainer);
    $("body").trigger("sizesReady");
  }

  function setAvailableSizes(color) {
    let sizes = colorLookup[color];
    /* keeping this around in case we go back to the native select
    sizeOptions.each(function () {
      let size = $(this).attr('value');
      $(this).prop('disabled', true);
      if (sizes && (sizes.indexOf(size) > -1)) {
        $(this).prop('disabled', false);
      }
    });*/

    $("#size-overlay-options button").each(function () {
      // console.log('sizes',sizes)
      let size = $(this).data("value");
      if (!$(this).hasClass('custom_btn')) {
        $(this).prop("disabled", true);
        if (sizes && sizes.indexOf(size) > -1) {
          $(this).prop("disabled", false);
        }
      }
    });
  }

  function setAvailableColors(size) {
    let colors = sizeLookup[size];
    colorOptions.each(function () {
      let color = $(this).data("value");
      $(this).addClass("disabled");
      if (colors && colors.indexOf(color) > -1) {
        $(this).removeClass("disabled");
      }
    });
  }

  function variantChange() {
    // Using sizeInput.prop('value') instead of sizeInput.val() because sizes might be disabled - val() returns null in that case
    // We want to allow the user to see the unavailable variants, but we're disabling the add to cart button so they can't buy them
    let newValueParts = [];
    newValueParts.push(colorHiddenInput.val());
    newValueParts.push(sizeInput.prop("value"));
    if (window.klaviyoProduct && window.klaviyoProduct.options && window.klaviyoProduct.options[0] === "Size") {
      newValueParts = [];
      newValueParts.push(sizeInput.prop("value"));
      newValueParts.push(colorHiddenInput.val());
    }

    // Filter out empty values
    newValueParts = newValueParts.filter(function (value) {
      return !!value;
    });
    let newValue = newValueParts.join(" / ");

    let variantId = null;
    let $selectedOption = $("select[name=id] option:selected").first();

    $("select[name=id]")
      .find("option")
      .each(function (i, e) {
        if ($(e).text() == newValue) {
          variantId = $(e).val();
          $selectedOption = $(e);
        }
      });
    if (!variantId) {
      $("#add-to-cart").prop("disabled", true).text(window.theme.strings.soldOut);
      return;
    }
    // console.log('variantId',variantId)

    $selectedOption.prop("selected", true).siblings().prop("selected", false);
    $selectedOption.parent()[0].dispatchEvent(new Event("change"));

    document.getElementById("product-variant-selection").value = variantId;

    // Update the browser location to match the selected variant ID
    const url = getUrlWithVariant(window.location.href, variantId);
    window.history.replaceState({ path: url }, "", url);

    // Disable/enable add to cart button based on variant in-stock availability
    if (window.product_variant_data) {
      let variant = window.product_variant_data.find(function (variant) {
        return variant.id === parseInt(variantId);
      });

      if (variant) {
        if (variant.available) {
          // If the variant is in stock, enable the add to cart button
          $("#add-to-cart").prop("disabled", false).text(window.theme.strings.addToCart);
        } else {
          // If the variant is out of stock, disable the add to cart button
          $("#add-to-cart").prop("disabled", true).text(window.theme.strings.soldOut);
        }
      }
    }
  }

  function changeImage() {
    // Hide images that don't match the selected color
    let colorHiddenInput = $("#color-selection");

    let sliderFilter = function () {
      if (!colorHiddenInput.val()) {
        return true;
      }

      // Colors have names in title case, but the image file names are somewhat inconsistent
      //   Example: Berry Space Dye is Berry-Spacedye in the image filename
      //   Example: Pebble Tie Dye is PebbleTieDye in the image filename
      //   Example: Vibrant Multi is Vibrant-Multi in the image filename
      //
      // So we'll match using case-insensitive, with optional characters between the words of the color names.
      // The filenames always have underscores before and after the color name, so we'll use that as the pattern.
      let colorPattern = new RegExp("_" + colorHiddenInput.val().replaceAll(" ", ".?") + "_", "i"),
        imageUrl = $(this).find("img").attr("src");
      // console.log('colorPattern',colorPattern)
      return !!imageUrl.match(colorPattern);
    };

    if (!$("body.template-product.styles-tavi").length || isSockProduct == true) {
      destroySliders();
      // Rebuild slider DOM elements based on filter
      mainImageSlider.children().remove();
      thumbnailSlider.children().remove();
    }

    let filteredMainImages = mainImageSliderSource.find(".image-slide-item").filter(sliderFilter);

    /* Show product images in two cols ONLY for TAVI for desktop */
    // console.log("filteredMainImages", filteredMainImages.length);
    if ($("body.template-product.styles-tavi").length || $("body.template-product.styles-toesox").length) {
      // if ($("body.template-product.styles-tavi").length && isSockProduct == false && $(window).width() > 768) {
      if (isSockProduct == false && $(window).width() >= 991) {
        filteredMainImages.show();
        mainImageSliderSource.removeClass("stackImage-true").addClass("stackImage-false");
        if (filteredMainImages.length < 3) {
          mainImageSliderSource.addClass("stackImage-true").removeClass("stackImage-false");
        }
        mainImageSliderSource.find(".image-slide-item").not(filteredMainImages).hide();
      }
    }

    if ($("body.template-product.styles-tavi").length || $("body.template-product.styles-toesox").length) {
      if (isSockProduct == true && $(window).width() <= 991) {
        console.log("this is sock pdp mobile");

        var taviSockMobile = $("#tavi-sock-image-slider");
        filteredMainImages.each(function () {
          $(this).clone().addClass("swiper-slide").appendTo(taviSockMobile.find(".swiper-wrapper"));
        });
        destroySockSwiperSlider();
        setTimeout(() => {
          initSockSwiperSlider();
        }, 50);
      }
    }

    if (!$("body.template-product.styles-tavi").length || isSockProduct == true) {
      filteredMainImages.each(function () {
        $(this).clone().appendTo(mainImageSlider);
      });
      let filteredThumbnails = thumbnailSliderSource.find(".image-thumbnail-item").filter(sliderFilter);
      filteredThumbnails.each(function () {
        $(this).clone().appendTo(thumbnailSlider);
      });
      $("#MainContent").imagesLoaded(initializeSliders);
    } else {
      /* Show product images in two cols ONLY for TAVI for desktop */
      mainImageSlider = $("#tavi-main-image-slider");
      filteredMainImages.each(function () {
        $(this).clone().addClass("swiper-slide").appendTo(mainImageSlider.find(".swiper-wrapper"));
      });

      $("#MainContent").imagesLoaded();
      destroySwiperSlider();
      setTimeout(() => {
        initSwiperSlider();
      }, 50);
    }

    let variantId = $("select[name=id]").val(),
      imageId = window.product_variant_images[variantId],
      slickIndex = $(".image-slide-item-" + imageId)
        .closest(".slick-slide")
        .data("slick-index");

    // slickIndex is undefined often, check first
    if (slickIndex) {
      mainImageSlider.slick("slickGoTo", slickIndex);
    }
  }

  function checkQtyOptions() {
    let qty = parseInt(quantityInput.val());
    if (qty > 1) {
      quantityDecrement.removeClass("disabled");
    } else {
      quantityDecrement.addClass("disabled");
    }
  }

  var colorArry = {};

  if ($("#product-detail-page").length) {
    window.product_variant_data.forEach(function (variant) {
      if (variant.available) {
        if (window.klaviyoProduct && window.klaviyoProduct.options) {
          if (window.klaviyoProduct.options[0] === "Color") {
            if (!colorLookup[variant.option1]) {
              colorLookup[variant.option1] = [];
            }
            colorLookup[variant.option1].push(variant.option2);
            if (!sizeLookup[variant.option2]) {
              sizeLookup[variant.option2] = [];
            }
            sizeLookup[variant.option2].push(variant.option1);
          } else {
            if (!colorLookup[variant.option2]) {
              colorLookup[variant.option2] = [];
            }
            colorLookup[variant.option2].push(variant.option1);
            if (!sizeLookup[variant.option1]) {
              sizeLookup[variant.option1] = [];
            }
            sizeLookup[variant.option1].push(variant.option2);
          }
        }
      }
    });

    //Hide color when no PO sap_quantity available for all sizes for any color
    window.product_variant_data.forEach(function (variant) {
      if (window.klaviyoProduct && window.klaviyoProduct.options) {
        if (window.klaviyoProduct.options[0] === "Color") {
          if (!colorArry[variant.option1]) {
            colorArry[variant.option1] = [];
          }
          var colorGrp = $(`.color-option-item[data-value="${variant.option1}"]`).attr("data-color-group");
          // console.log('colorGrp',variant.option1,colorGrp);
          if (colorGrp == undefined) {
            colorGrp = "core";
          }
          if (colorGrp) {
            variant["color_group"] = colorGrp;
          }
          colorArry[variant.option1].push(variant);
        } else {
          if (!colorArry[variant.option2]) {
            colorArry[variant.option2] = [];
          }
          var colorGrp = $(`.color-option-item[data-value="${variant.option2}"]`).attr("data-color-group");
          // console.log('colorGrp',variant.option1,colorGrp);
          if (colorGrp == undefined) {
            colorGrp = "core";
          }
          if (colorGrp) {
            variant["color_group"] = colorGrp;
          }
          colorArry[variant.option2].push(variant);
        }
      }
    });

    //hide colors when no PO for all sizes of any color
    // for (const key in colorArry) {
    //   var color = key,
    //     colorSizes = colorArry[color];
    //   var availableSizes = colorSizes.filter((v) => {
    //     return (
    //       v.available == false && (v.sap_incoming_quantity == 0 || v.sap_incoming_quantity == "NA") && v.color_group == "core"
    //     );
    //   });
    //   var $color_elemnt = $(`.color-option-item[data-value="${color}"]`);
    //   if (availableSizes.length == colorSizes.length) {
    //     if ($color_elemnt.length > 0) {
    //       $color_elemnt.hide();
    //       // console.log('color',color,'colorSizes',colorSizes,availableSizes)
    //     }
    //   }
    // }
    //Ends here

    if ($('[data-option-name="Size"]').length) {
      // wait for the resorting of sizes to be done before setting the variant. option values are not found otherwise.
      $("body").on("sizesReady", setInitialColorVariant);
      sortSizeOptions();
    } else {
      setInitialColorVariant();
    }

    if ($("#color-selection").length) {
      var currentColorSelected = $("#color-selection").val().trim();
      var colorOption = $(`.color-option-item[data-value="${currentColorSelected}"]`),
        colorGroup = colorOption.attr("data-color-group");
      if ($(".swatch-group-title").length > 0 && colorGroup) {
        $(".js-selected-color-name").empty();
        // console.log('currentColorSelected',currentColorSelected)
        $(`.swatch-group-title[data-group-parent="${colorGroup}"] .js-selected-color-name`).text(`: ${currentColorSelected}`);
      }
    }

    // this needs to be above calls to setInitialColorVariant so the color click event is listening
    colorOptions.on("click", function () {
      // if($(this).hasClass('disabled')) return;

      let color = $(this).data("value"),
        colorGroup = $(this).attr("data-color-group");
      $(this).addClass("selected").siblings().removeClass("selected");
      colorHiddenInput.val(color);
      $(".js-selected-color-name").empty();
      if ($(".swatch-group-title").length > 0 && colorGroup) {
        //PDP has Color groups
        $(`h4.swatch-group-title[data-group-parent="${colorGroup}"] .color-${colorGroup}-selected`).text(`: ${color}`);
      } else {
        colorSelectionLabel.text(color);
      }

      setAvailableSizes(color);
      variantChange();
      changeImage();
    });

    disableUnavailableOptions();

    if (!$("body.template-product.styles-tavi").length || isSockProduct == true) {
      $("#MainContent").imagesLoaded(initializeSliders);
    }

    sizeInput.on("change", function () {
      setAvailableColors($(this).val());
      variantChange();
    });

    // check color availability when we don't have size options, otherwise setAvailableColors never fires
    if (!$("#size-selection").length) {
      setAvailableColors(null);
    }

    $('select[name="id"]').on("change", function () {
      let variantId = $(this).val();

      let variant = window.product_variant_data.find(function (variant) {
        return variant.id === parseInt(variantId);
      });

      if (variant) {
        // update price
        $(".primary-product-details .product-price").text("$" + (variant.price / 100).toFixed(2));
      }
    });

    /**
     * Quantity Controls
     */

    quantityIncrement.on("click", function () {
      let currentVal = parseInt(quantityInput.val());
      quantityInput.val(currentVal + 1);
      checkQtyOptions();
    });

    quantityDecrement.on("click", function () {
      let currentVal = parseInt(quantityInput.val());
      if (currentVal > 1) {
        quantityInput.val(currentVal - 1);
      }
      checkQtyOptions();
    });

    checkQtyOptions();

    /**
     * Size Chart Controls
     */

    let sizeChartToggle = $("#size-chart-toggle"),
      sizeChartModal = $("#size-chart-modal"),
      sizeChartModalInner = sizeChartModal.find(".chart-modal-inner"),
      sizeChartModalClose = $("#size-chart-modal-close");

    sizeChartToggle.on("click", function () {
      sizeChartModal.addClass("active");
    });

    sizeChartModalClose.on("click", function () {
      sizeChartModal.removeClass("active");
    });

    sizeChartModalInner.on("click", function (e) {
      e.stopPropagation();
    });

    sizeChartModal.on("click", function () {
      sizeChartModal.removeClass("active");
    });

    /**
     * Add to Cart Button Handling
     */

    let getCartCount = function () {
      $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
        success: function (res) {
          $(".cart-count").text(res.item_count);
        },
        error: function (err) {
          console.log(err);
        },
      });
    };

    let addToCartButton = $("#add-to-cart");

    addToCartButton.on("click", function (e) {
      var currentSelectSize = $("#size-selection-toggle");
      // console.log('current',currentSelectSize.text().toLocaleLowerCase());
      var selectLabl = currentSelectSize.text().toLocaleLowerCase().trim();
      if (currentSelectSize.text().toLocaleLowerCase().trim() == "select a size" || currentSelectSize.text().toLocaleLowerCase().trim() == "select amount") {
        alert("Please " + selectLabl);
        e.preventDefault();
        return;
      }
      if ($(this).hasClass("loading")) return;

      e.preventDefault();

      addToCartButton.addClass("loading");
      addToCartButton.text("Loading...");

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: $(this).closest("form").serialize(),
        success: function (res) {
          // TODO update the cart count for now
          addToCartButton.removeClass("loading");
          addToCartButton.text("Added To Cart!");
          setTimeout(() => {
            addToCartButton.text("Add to Cart");
          }, 2000);
          $.ajax({
            type: "GET",
            url: "/cart.js",
            dataType: "json",
            success: function (cart) {
              // Trigger the custom event 'AjaxAdded' with the updated cart data
              $(document).trigger("AjaxAdded", [cart]);
            },
            error: function (err) {
              console.log("Error fetching cart data:", err);
            }
          });
        },
        error: function (err) {
          console.log(err);
          addToCartButton.removeClass("loading");
          addToCartButton.text("Add to Cart");
        },
        complete: function () {
          getCartCount();
        },
      });
    });

    variantChange();
  }



  let accordionToggles = $(".product-details-accordion-header");

  accordionToggles.on("click", function () {
    let accordion = $(this).parent(".product-details-accordion-item"),
      accordionContent = accordion.find(".product-details-accordion-content"),
      otherAccordions = accordion.siblings(".product-details-accordion-item");

    if (accordion.hasClass("accordion-open")) {
      accordion.removeClass("accordion-open");
      accordionContent.slideUp();
    } else {
      accordion.addClass("accordion-open");
      accordionContent.slideDown();
      otherAccordions.removeClass("accordion-open");
      otherAccordions.find(".product-details-accordion-content").slideUp();
    }
  });

  /* Klaviyo PDP tracking */
  window.trackKlaviyo(window.klaviyoProduct, window.location);

  function videoOverlayClose() {
    if ($("#pdp-video-overlay video").length) {
      $("#pdp-video-overlay video")[0].pause();
      $("#pdp-video-overlay").attr("aria-hidden", true);
      $("#pdp-video-overlay .close").attr("tabindex", -1);
      $("body").removeClass("pdp-video-shown");
    }
  }

  $(".split-highlight-video-trigger").on("click", function (e) {
    e.preventDefault();
    $("body").addClass("pdp-video-shown");
    $("#pdp-video-overlay .close").attr("tabindex", 1);
    window.helpers.triggerEl = $(this);
    window.helpers.trapFocus("#pdp-video-overlay");
    $("#pdp-video-overlay").attr("aria-hidden", false);
  });
  $("#pdp-video-overlay .close").on("click", function (e) {
    e.preventDefault();
    videoOverlayClose();
    window.helpers.returnFocus();
  });

  $("body").on("keyup", function (e) {
    if (window.helpers.isEscape(e)) {
      videoOverlayClose();
      $("body").removeClass("size-selection-shown");
      $("body").removeClass("custom-size-selection-shown");
      window.helpers.returnFocus();
    }
  });

  $("#size-selection-toggle").on("click", function (e) {
    // if(!$(this).hasClass('custom-size-selection-toggle')){
    e.preventDefault();
    e.stopPropagation();
    $("body").addClass("size-selection-shown");
    $(this).attr("aria-expanded", true);
    window.helpers.triggerEl = $(this);
    window.helpers.trapFocus("#size-selection-overlay");
    // }
  });
  // click anywhere to close, even though there's a button
  $("body").on("click", function (e) {
    $("body").removeClass("size-selection-shown");
    $("body").removeClass("custom-size-selection-shown");
    // $('body').removeClass('body_hidden')
  });
  $("#size-overlay-options button").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $("#size-overlay-options button").removeClass("selected");
    $(this).addClass("selected");
    $("#size-selection").val($(this).data("value")).trigger("change");
    var sizeNo = $(this).attr("data-size-no"),
      sizeText = $(this).data("value");
    var sizeLable = sizeNo.length ? `${sizeText} ${sizeNo}` : `${sizeText}`;
    $("#size-selection-toggle").text(sizeLable);
    $("body").removeClass("size-selection-shown");
  });
});

/**
 * @param {*} product
 * @param {*} location
 * @returns
 */
window.trackKlaviyo = (product, location) => {
  let klaviyoLocation = "";
  if (location && location.href) {
    klaviyoLocation = location.href.split("?")[0];
  }

  if (typeof product === "undefined") return;

  const item = {
    Name: product.title,
    ProductID: product.id,
    Categories: product.collections && product.collections.length > 0 ? product.collections[0].title : "",
    ImageURL: product.featured_image ? product.featured_image : "",
    URL: klaviyoLocation,
    Brand: product.vendor,
    Price: product.variants && product.variants.length > 0 ? product.variants[0].price : 0,
    CompareAtPrice: product.variants && product.variants.length > 0 ? product.variants[0].compare_at_price : 0,
  };

  const viewedItem = {
    token: "VTL4ep",
    event: "Viewed Product",
    properties: item,
  };

  const trackViewedItem = {
    token: "VTL4ep",
    event: "trackViewedItem",
    properties: {
      Title: item.Name,
      ItemId: item.ProductID,
      Categories: item.Categories,
      ImageUrl: item.ImageURL,
      Url: item.URL,
      Metadata: {
        Brand: item.Brand,
        Price: item.Price,
        CompareAtPrice: item.CompareAtPrice,
      },
    },
  };

  const viewedItemScript = document.createElement("script");

  viewedItemScript.src = `https://a.klaviyo.com/api/track?data=${btoa(unescape(encodeURIComponent(JSON.stringify(viewedItem))))}`;
  viewedItemScript.async = true;

  document.body.appendChild(viewedItemScript);

  const trackViewedItemScript = document.createElement("script"); 

  trackViewedItemScript.src = `https://a.klaviyo.com/api/track?data=${btoa(unescape(encodeURIComponent(JSON.stringify(trackViewedItem))))}`;
  trackViewedItemScript.async = true;

  document.body.appendChild(trackViewedItemScript);

  return () => {
    document.body.removeChild(viewedItemScript);
    document.body.removeChild(trackViewedItemScript);
  };
};

function getQueryParams(url) {
  const paramArr = url.slice(url.indexOf("?") + 1).split("&");
  const params = {};
  paramArr.map((param) => {
    const [key, val] = param.split("=");
    params[key] = decodeURIComponent(val);
  });
  return params;
}

// document.addEventListener('DOMContentLoaded', function() {
//     const productJson = document.querySelectorAll('[id^=ProductJson-');
//
//     if (productJson.length > 0) {
//         for (let i = 0; i < productJson.length; i++) {
//             const current = productJson[i];
//             const sectionId = current.id.replace('ProductJson-', '');
//             const section = document.querySelector('[data-section-id="' + sectionId + '"]');
//             const product = JSON.parse(current.text);
//
//             if (product.options.length === 1) {
//                 const unavailableVariants = [];
//
//                 for (let j = 0; j < product.variants.length; j++) {
//                     const variant = product.variants[j];
//
//                     if (!variant.available) {
//                         unavailableVariants.push(variant);
//                     }
//                 }
//
//                 if (unavailableVariants.length > 0) {
//                     const mutationCallback = function() {
//                         const variantOptions = section.querySelectorAll('.single-option-selector option');
//
//                         if (variantOptions.length > 0) {
//                             for (let k = 0; k < unavailableVariants.length; k++) {
//                                 const unavailableVariant = unavailableVariants[k];
//
//                                 for (let l = 0; l < variantOptions.length; l++) {
//                                     const option = variantOptions[l];
//
//                                     if (unavailableVariant.title === option.value) {
//                                         option.remove();
//                                     }
//                                 }
//                             }
//
//                             if (typeof observer === 'object' && typeof observer.disconnect === 'function') {
//                                 observer.disconnect();
//                             }
//                         }
//                     }
//
//                     const observer = new MutationObserver(mutationCallback);
//                     const addToCartForm = document.querySelector('form[action*="/cart/add"]');
//
//                     mutationCallback();
//
//                     if (window.MutationObserver && addToCartForm.length) {
//                         const config = { childList: true, subtree: true };
//
//                         if (typeof observer === 'object' && typeof observer.disconnect === 'function') {
//                             observer.disconnect();
//                         }
//
//                         observer.observe(addToCartForm, config);
//                     }
//                 }
//             }
//         }
//     }
// });
